/**
 * @generated SignedSource<<978b69720996d8c32600b7dacc6a6464>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UpdateServiceOptionInput = {
  name?: string | null;
  price?: number | null;
  scoroProductId?: number | null;
};
export type ServiceOptionEditFormMutation$variables = {
  id: string;
  input: UpdateServiceOptionInput;
};
export type ServiceOptionEditFormMutation$data = {
  readonly updateServiceOption: {
    readonly " $fragmentSpreads": FragmentRefs<"EntitySidebar_entity" | "ServiceOptionEditForm_serviceOption">;
  };
};
export type ServiceOptionEditFormMutation = {
  response: ServiceOptionEditFormMutation$data;
  variables: ServiceOptionEditFormMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  },
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ServiceOptionEditFormMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ServiceOption",
        "kind": "LinkedField",
        "name": "updateServiceOption",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "EntitySidebar_entity"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ServiceOptionEditForm_serviceOption"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ServiceOptionEditFormMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ServiceOption",
        "kind": "LinkedField",
        "name": "updateServiceOption",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "uuid",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "createdAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "updatedAt",
                "storageKey": null
              }
            ],
            "type": "Entity",
            "abstractKey": "__isEntity"
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "scoroProductId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "price",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "ce0a21bf624ec655ca52a7a14db89776",
    "id": null,
    "metadata": {},
    "name": "ServiceOptionEditFormMutation",
    "operationKind": "mutation",
    "text": "mutation ServiceOptionEditFormMutation(\n  $id: ID!\n  $input: UpdateServiceOptionInput!\n) {\n  updateServiceOption(id: $id, input: $input) {\n    ...EntitySidebar_entity\n    ...ServiceOptionEditForm_serviceOption\n    id\n  }\n}\n\nfragment EntitySidebar_entity on Entity {\n  __isEntity: __typename\n  uuid\n  createdAt\n  updatedAt\n}\n\nfragment ServiceOptionEditForm_serviceOption on ServiceOption {\n  id\n  name\n  scoroProductId\n  price\n}\n"
  }
};
})();

(node as any).hash = "14043f02b5eb36fc6a0a187611c7f7ad";

export default node;
